/* BloomingFlower (Oct 17, 2026): beanie-set add-ons inside the PageFly Smart Cart drawer.
   When the Mama & Mini Matching Knit Beanie Set is in the cart with no spending threshold,
   suggest Teddy Bear Socks first and the Cloth Book second, each labeled with the automatic
   bundle saving. Two compact rows, no carousel. Savings are applied by Shopify automatic
   discounts; this file only suggests and adds items (POST /cart/add.js).
   Replaces the Oct 16 version, which targeted the native Horizon drawer that Smart Cart hides. */
(function () {
  if (window.__bfAov) return; window.__bfAov = 1;
  var BEANIE = 'mama-mini-ribbed-knit-beanie-set';
  var OFFERS = [
    { handle: 'teddy-bear-baby-socks-1-pair', off: 0, name: 'Teddy Bear Socks', note: 'Pairs with the beanie set' }, /* Oct 22: no $1.99 socks discount applies in cart (cart.js test), so no saving claim */
    { handle: 'high-contrast-soft-cloth-book', off: 0, name: 'Soft Cloth Book', note: 'Completes the gift set' }
  ];
  var CSS = '.bf-aov{padding:12px 16px 14px;background:#fdeff0;color:#3f3533;font-size:13px;line-height:1.35}' +
    '.bf-aov[hidden]{display:none}' +
    '.bf-aov__h{margin:0 0 6px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;color:#934b59}' +
    '.bf-aov__row{display:grid;grid-template-columns:48px 1fr auto;gap:10px;align-items:center;padding:8px 0;border-top:1px solid rgba(169,92,104,.18)}' +
    '.bf-aov__img{width:48px;height:48px;object-fit:cover;display:block;background:#fffdfb}' +
    '.bf-aov__t{display:block;font-weight:600;font-size:14px;color:#3f3533;text-decoration:none}' +
    '.bf-aov__p{display:block;color:#6b5f5c;margin-top:1px}.bf-aov__p b{color:#934b59;font-weight:700}' +
    '.bf-aov__s{margin-top:5px;max-width:100%;min-height:30px;padding:3px 8px;font:inherit;font-size:12px;color:#3f3533;background:#fffdfb;border:1px solid rgba(169,92,104,.35);border-radius:999px}' +
    '.bf-aov__b{min-height:36px;min-width:64px;padding:6px 14px;font:inherit;font-size:13px;font-weight:600;color:#fffdfb;background:#934b59;border:0;border-radius:999px;cursor:pointer}' +
    '.bf-aov__b:hover{background:#e98ca7;color:#2d1a1f}.bf-aov__b[aria-busy="true"]{opacity:.7}' +
    '.bf-aov__b:focus-visible,.bf-aov__s:focus-visible{outline:2px solid #934b59;outline-offset:2px}';
  var cart = null, products = {}, sr = null, mo = null, timer = 0, busy = false;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(p) {
    var u = p.featured_image || (p.images && p.images[0]) || '';
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }
  /* Oct 22: the price shown is the price the cart charges, rendered by Liquid (bf-sale-price via bf-look-variants)
     into data-bf-aov-prices on sections/bf-look-data. No eligibility logic here. Unknown price = no price shown. */
  var prices = null, pricesP = null;
  function loadPrices() {
    if (prices) return Promise.resolve(prices);
    if (pricesP) return pricesP;
    pricesP = fetch('/?sections=bf-look-data', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var t = document.createElement('template'); t.innerHTML = j['bf-look-data'] || '';
        var n = t.content.querySelector('[data-bf-aov-prices]');
        var raw = n ? JSON.parse(n.getAttribute('data-bf-aov-prices') || '{}') : {}, out = {};
        Object.keys(raw).forEach(function (h) { (raw[h] || []).forEach(function (v) { out[v[0]] = v[3]; }); });
        prices = out; return prices;
      })
      .catch(function () { pricesP = null; return null; });
    return pricesP;
  }
  function priceOf(id) { return prices && prices[id] != null ? money(prices[id]) : ''; }
  function load(h) {
    if (products[h] !== undefined) return Promise.resolve(products[h]);
    return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { products[h] = p; return p; });
  }
  function wanted() {
    if (!cart || !cart.items) return [];
    var inBag = {}, has = false;
    cart.items.forEach(function (i) { inBag[i.handle] = true; if (i.handle === BEANIE) has = true; });
    if (!has) return [];
    return OFFERS.filter(function (o) { return !inBag[o.handle]; });
  }
  function host() { var h = document.getElementById('smart-cart-host'); return h && h.shadowRoot ? h.shadowRoot : null; }
  function render() {
    var root = host();
    if (!root) return;
    if (sr !== root) {
      sr = root;
      var st = document.createElement('style'); st.textContent = CSS; root.appendChild(st);
      if (mo) mo.disconnect();
      mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && t.closest('[data-bf-aov]')) continue;
          clearTimeout(timer); timer = setTimeout(place, 120); return;
        }
      });
      mo.observe(root, { childList: true, subtree: true });
    }
    place();
  }
  function place() {
    var root = host(); if (!root) return;
    var body = root.querySelector('.sc-drawer__body');
    var el = root.querySelector('[data-bf-aov]');
    var list = wanted().filter(function (o) { return products[o.handle]; });
    if (!body || !list.length) { if (el) el.remove(); return; }
    var key = list.map(function (o) { return o.handle; }).join(',');
    if (!el || el.parentNode !== body) {
      if (el) el.remove();
      el = document.createElement('div');
      el.className = 'bf-aov'; el.setAttribute('data-bf-aov', ''); el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'Add to your beanie set');
      var anchor = body.querySelector('[data-section-id="sec-recommendations"]');
      if (!anchor) { var items = body.querySelector('[data-section-id="sec-cart-items"]'); anchor = items ? items.nextSibling : null; }
      body.insertBefore(el, anchor);
      el.addEventListener('click', onClick);
      el.addEventListener('change', function (e) { var s = e.target; if (!s.matches || !s.matches('select.bf-aov__s')) return; var n = s.closest('.bf-aov__row').querySelector('[data-bf-aov-price]'); if (n) n.textContent = priceOf(+s.value); });
    }
    key += prices ? '|p' : '';
    if (el.getAttribute('data-k') === key) return;
    el.setAttribute('data-k', key);
    var html = '<p class="bf-aov__h">Complete your beanie set</p>';
    list.forEach(function (o) {
      var p = products[o.handle];
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) return;
      var sel = vs.length > 1
        ? '<select class="bf-aov__s" aria-label="' + esc(o.name) + ' option">' + vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
        : '<input type="hidden" class="bf-aov__s" value="' + vs[0].id + '">';
      html += '<div class="bf-aov__row">' +
        (img(p) ? '<img class="bf-aov__img" src="' + esc(img(p)) + '" width="48" height="48" alt="" loading="lazy">' : '<span></span>') +
        '<div><a class="bf-aov__t" href="/products/' + o.handle + '">' + esc(o.name) + '</a>' +
        '<span class="bf-aov__p">' + (priceOf(vs[0].id) ? '<span data-bf-aov-price>' + priceOf(vs[0].id) + '</span> &middot; ' : '') + '<b>' + (o.off ? money(o.off) + ' less with your beanie set' : esc(o.note || '')) + '</b></span>' + sel + '</div>' +
        '<button type="button" class="bf-aov__b">Add</button></div>';
    });
    el.innerHTML = html;
  }
  function onClick(e) {
    var b = e.target.closest && e.target.closest('.bf-aov__b');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    var row = b.closest('.bf-aov__row'), s = row.querySelector('.bf-aov__s');
    if (!s || !s.value) return;
    b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding\u2026';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +s.value, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { var rt = window.__SMART_CART_RUNTIME__; if (rt && rt.refresh) { try { rt.refresh(); } catch (x) {} } refresh(); })
      .catch(function () { b.removeAttribute('aria-busy'); b.textContent = 'Add'; });
  }
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = c;
        var w = wanted();
        return Promise.all(w.map(function (o) { return load(o.handle); }).concat(w.length ? [loadPrices()] : []));
      })
      .then(function () { busy = false; render(); })
      .catch(function () { busy = false; });
  }
  var rq = 0;
  function soon() { clearTimeout(rq); rq = setTimeout(refresh, 250); }
  var f0 = window.fetch;
  if (f0) window.fetch = function (input) {
    var p = f0.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var path = u.replace(location.origin, '').split('?')[0];
      if (/(^|\/)cart\/(add|change|update|clear)(\.js|\.json)?$/.test(path)) p.then(function (r) { if (r && r.ok) soon(); }).catch(function () {});
    } catch (e) {}
    return p;
  };
  document.addEventListener('cart:update', soon);
  function start() {
    new MutationObserver(function () { if (host() && sr !== host()) render(); }).observe(document.body, { childList: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* BloomingFlower (Oct 22, 2026): "Complete the look" one-tap add-ons (Eduardo approved 10:31 AM MDT).
   Product page: blocks/bf-complete-look.liquid prints the add-on data; this draws the controls.
   Cart drawer (PageFly Smart Cart shadow DOM, or the native #bf-cd drawer when Smart Cart is off): one row per paired
   add-on that isn't in the bag yet, data from /?sections=bf-look-data. Pairings live in snippets/bf-look-map.
   Prices are the store's current sale display amount from Liquid (no % off wording). Sold-out products are left out,
   sold-out options are disabled. Adds with POST /cart/add.js (Shopify add-to-cart customer events still fire). */
(function () {
  if (window.__bfLook) return; window.__bfLook = 1;
  var d = document;
  var CSS = '.bf-look{margin:4px 0 2px;padding:12px 14px;background:#fdeff0;border-radius:14px;color:#3f3533;font-size:14px;line-height:1.35}' +
    '.bf-look--sc{margin:0;border-radius:0;padding:12px 16px 14px}' +
    '.bf-look__h{margin:0 0 8px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;color:#934b59}' +
    '.bf-look__row{display:grid;grid-template-columns:64px 1fr;gap:12px;align-items:start}.bf-look--sc .bf-look__row{grid-template-columns:48px 1fr}' +
    '.bf-look--sc .bf-look__row+.bf-look__row{margin-top:10px;padding-top:10px;border-top:1px solid rgba(169,92,104,.18)}' +
    '.bf-look__img{display:block;width:64px;height:64px;border-radius:10px;overflow:hidden;background:#fffdfb}.bf-look--sc .bf-look__img{width:48px;height:48px;border-radius:8px}' +
    '.bf-look__img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.bf-look__t{display:block;font-weight:600;color:#3f3533;text-decoration:none}' +
    '.bf-look__p{display:block;margin:1px 0 6px;color:#6b5f5c}' +
    '.bf-look__s{display:block;margin:0 0 8px;max-width:100%;min-height:36px;padding:4px 10px;font:inherit;font-size:13px;color:#3f3533;background:#fffdfb;border:1px solid rgba(169,92,104,.35);border-radius:999px}' +
    '.bf-look__btns{display:flex;flex-wrap:wrap;gap:6px}' +
    '.bf-look__b{display:inline-flex;flex-direction:column;align-items:center;justify-content:center;min-height:44px;min-width:88px;padding:5px 12px;font:inherit;font-size:13px;font-weight:600;line-height:1.15;color:#fffdfb;background:#934b59;border:0;border-radius:999px;cursor:pointer}' +
    '.bf-look__b small{font-size:11px;font-weight:500;opacity:.9}' +
    '.bf-look__b:hover{background:#e98ca7;color:#2d1a1f}.bf-look__b[aria-busy="true"]{opacity:.7}' +
    '.bf-look__b:disabled{background:#d9c9c6;color:#6b5f5c;cursor:not-allowed}' +
    '.bf-look__b:focus-visible,.bf-look__s:focus-visible{outline:2px solid #934b59;outline-offset:2px}' +
    '.bf-look__msg{margin:6px 0 0;font-size:13px;color:#934b59}.bf-look__msg:empty{display:none}' +
    '[data-bf-look-one]>[data-bf-aov]{display:none!important}';
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function split(s) { var m = /^(.*?)\s*\((.*)\)\s*$/.exec(s || ''); return m ? [m[1], m[2]] : [s, '']; }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }
  /* Variant row: [id, option1, option2, display cents, available] */
  function controls(p) {
    var v = p.v || [], opts = p.o || [], two = opts.length >= 2;
    var o1 = uniq(v.filter(function (x) { return x[4]; }).map(function (x) { return x[1]; }));
    if (!o1.length) return '';
    /* default option1: the first value with every option2 in stock, else the first value with any stock */
    var def = o1[0];
    if (two) for (var i = 0; i < o1.length; i++) { if (v.filter(function (x) { return x[1] === o1[i]; }).every(function (x) { return x[4]; })) { def = o1[i]; break; } }
    var h = '';
    if (o1.length > 1) {
      h += '<select class="bf-look__s" data-bf-look-o1 aria-label="' + esc(opts[0] || 'Option') + '">' +
        o1.map(function (x) { return '<option value="' + esc(x) + '"' + (x === def ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select>';
    } else {
      h += '<input type="hidden" data-bf-look-o1 value="' + esc(def) + '">';
    }
    if (two) {
      var o2 = uniq(v.map(function (x) { return x[2]; }));
      h += '<div class="bf-look__btns" role="group" aria-label="' + esc(opts[1]) + '">' + o2.map(function (x) {
        var s = split(x);
        return '<button type="button" class="bf-look__b" data-bf-look-add data-o2="' + esc(x) + '"><span>Add ' + esc(s[0]) + '</span><small data-bf-look-bp>' + (s[1] ? esc(s[1]) + ' · ' : '') + '</small></button>';
      }).join('') + '</div>';
    } else {
      h += '<div class="bf-look__btns"><button type="button" class="bf-look__b" data-bf-look-add><span>Add</span><small data-bf-look-bp></small></button></div>';
    }
    return h;
  }
  function find(p, o1, o2) {
    var v = p.v || [];
    for (var i = 0; i < v.length; i++) if (v[i][1] === o1 && (o2 == null || v[i][2] === o2)) return v[i];
    return null;
  }
  /* Refresh button state and prices for the chosen option1. */
  function sync(box, p) {
    var o1el = box.querySelector('[data-bf-look-o1]'); if (!o1el) return;
    var o1 = o1el.value;
    box.querySelectorAll('[data-bf-look-add]').forEach(function (b) {
      if (b.getAttribute('aria-busy') === 'true') return;
      var o2 = b.hasAttribute('data-o2') ? b.getAttribute('data-o2') : null;
      var x = find(p, o1, o2), s = split(o2 || ''), lab = o2 ? s[0] : '';
      var bp = b.querySelector('[data-bf-look-bp]');
      b.disabled = !(x && x[4]);
      if (x) b.setAttribute('data-id', x[0]); else b.removeAttribute('data-id');
      if (bp) { var wasHtml = (x && x[4] && x[5] && x[5] > x[3]) ? ' <s class="bf-sale__was">' + money(x[5]) + '</s>' : ''; bp.innerHTML = (s[1] ? esc(s[1]) + ' · ' : '') + (x ? (x[4] ? money(x[3]) + wasHtml : 'Sold out') : 'Unavailable'); }
      var hasWas = !!(x && x[4] && x[5] && x[5] > x[3]), holder = box.querySelector('.bf-look__t') ? box.querySelector('.bf-look__t').parentNode : null;
      if (holder) { var bd = holder.querySelector('[data-bf-look-badge]'); if (hasWas && !bd) { bd = d.createElement('span'); bd.className = 'bf-sale__badge'; bd.setAttribute('data-bf-look-badge', ''); bd.textContent = 'Black Friday \u00b7 20% off'; var tl = holder.querySelector('.bf-look__t'); tl.parentNode.insertBefore(bd, tl.nextSibling); } else if (!hasWas && bd) { bd.parentNode.removeChild(bd); } }
      b.setAttribute('aria-label', 'Add ' + p.t + (o1 ? ', ' + o1 : '') + (lab ? ', ' + o2 : '') + (x ? (x[4] ? ', ' + money(x[3]) : ', sold out') : ''));
    });
  }
  function openCart() {
    var rt = window.__SMART_CART_RUNTIME__;
    if (rt) { try { rt.refresh && rt.refresh(); } catch (e) {} try { rt.open && rt.open('manual'); } catch (e) {} return; }
    /* Native #bf-cd drawer opens itself from its /cart/add fetch hook. */
  }
  function add(box, b, inDrawer) {
    var id = b.getAttribute('data-id'), msg = box.querySelector('[data-bf-look-msg]');
    if (!id || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    var keep = b.innerHTML;
    b.setAttribute('aria-busy', 'true'); b.innerHTML = '<span>Adding\u2026</span>';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        b.removeAttribute('aria-busy'); b.innerHTML = keep;
        if (!x.ok) { if (msg) msg.textContent = (x.j && (x.j.description || x.j.message)) || 'Couldn\u2019t add that item. Please try again.'; return; }
        if (msg) msg.textContent = 'Added to your cart.';
        d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        if (inDrawer) { var rt = window.__SMART_CART_RUNTIME__; if (rt && rt.refresh) try { rt.refresh(); } catch (e) {} }
        else openCart();
      })
      .catch(function () { b.removeAttribute('aria-busy'); b.innerHTML = keep; if (msg) msg.textContent = 'Couldn\u2019t add that item. Please try again.'; });
  }
  function wire(box, p, inDrawer) {
    var ctl = box.querySelector('[data-bf-look-ctl]');
    if (ctl && !ctl.children.length) ctl.innerHTML = controls(p);
    sync(box, p);
    box.addEventListener('change', function (e) { if (e.target.matches('[data-bf-look-o1]')) sync(box, p); });
    box.addEventListener('click', function (e) { var b = e.target.closest('[data-bf-look-add]'); if (b) add(box, b, inDrawer); });
  }
  /* Product page blocks */
  function pdp() {
    if (!styled && d.querySelector('[data-bf-look]')) { styled = true; var s0 = d.createElement('style'); s0.textContent = CSS; d.head.appendChild(s0); }
    d.querySelectorAll('[data-bf-look]:not([data-wired])').forEach(function (box) {
      box.setAttribute('data-wired', '');
      var s = box.querySelector('[data-bf-look-data]'); if (!s) return;
      try { wire(box, JSON.parse(s.textContent), false); } catch (e) {}
    });
  }
  /* Cart drawer rows */
  var data = null, loading = null, cart = null, sr = null, mo = null, t = 0, styled = false;
  function getData() {
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    loading = fetch('/?sections=bf-look-data', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var tpl = d.createElement('template'); tpl.innerHTML = j['bf-look-data'] || '';
      var s = tpl.content.querySelector('[data-bf-look-all]');
      data = s ? JSON.parse(s.textContent) : { map: {}, p: {} }; return data;
    }).catch(function () { loading = null; return null; });
    return loading;
  }
  function wanted() {
    if (!cart || !cart.items || !data) return [];
    var bag = {}, out = [];
    cart.items.forEach(function (i) { bag[i.handle] = true; });
    cart.items.forEach(function (i) { var a = data.map[i.handle]; if (a && !bag[a] && data.p[a] && out.indexOf(a) < 0) out.push(a); });
    return out.slice(0, 2);
  }
  function target() {
    var h = d.getElementById('smart-cart-host');
    if (h && h.shadowRoot) {
      /* Watch the Smart Cart shadow root as soon as it exists, before its drawer body is drawn (Oct 22 fix: a bag
         filled on an earlier page, then the drawer opened later, could miss the row). */
      if (sr !== h.shadowRoot) {
        sr = h.shadowRoot; var st = d.createElement('style'); st.textContent = CSS; sr.appendChild(st);
        if (mo) mo.disconnect();
        mo = new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { var x = m[i].target; if (x && x.closest && x.closest('[data-bf-look-cart]')) continue; clearTimeout(t); t = setTimeout(place, 120); return; } });
        mo.observe(sr, { childList: true, subtree: true });
      }
      var b = sr.querySelector('.sc-drawer__body');
      if (!b) return null;
      return { body: b, anchor: b.querySelector('[data-bf-aov]') || b.querySelector('[data-section-id="sec-recommendations"]') };
    }
    var cd = d.querySelector('#bf-cd .bf-cd__scroll');
    if (cd) { if (!styled) { styled = true; var s2 = d.createElement('style'); s2.textContent = CSS; d.head.appendChild(s2); } return { body: cd, anchor: cd.querySelector('.bf-cd__up') || cd.querySelector('[data-bf-cd-recs]') }; }
    return null;
  }
  function place() {
    var tg = target(); if (!tg) return;
    var root = tg.body.getRootNode ? tg.body.getRootNode() : d;
    var el = root.querySelector('[data-bf-look-cart]');
    var list = wanted();
    /* One offer at a time (Oct 22): while the tights row for the Beanie Set shows, the socks/book rows step aside. */
    var bsA = data && data.map ? data.map['mama-mini-ribbed-knit-beanie-set'] : '';
    if (bsA && list.indexOf(bsA) >= 0) tg.body.setAttribute('data-bf-look-one', ''); else tg.body.removeAttribute('data-bf-look-one');
    if (!list.length) { if (el) el.remove(); return; }
    var key = list.join(',') + '|' + cart.item_count;
    if (el && el.parentNode === tg.body && el.getAttribute('data-k') === key) return;
    if (el) el.remove();
    el = d.createElement('div');
    el.className = 'bf-look bf-look--sc'; el.setAttribute('data-bf-look-cart', ''); el.setAttribute('data-k', key);
    el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'Complete the look');
    el.innerHTML = '<p class="bf-look__h">Complete the look</p>';
    list.forEach(function (h) {
      var p = data.p[h];
      var row = d.createElement('div'); row.className = 'bf-look__row'; row.setAttribute('data-h', h);
      row.innerHTML = (p.i ? '<a class="bf-look__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.i) + '" width="48" height="48" alt="" loading="lazy"></a>' : '<span></span>') +
        '<div class="bf-look__info"><a class="bf-look__t" href="' + esc(p.u) + '">' + esc(p.t) + '</a><div data-bf-look-ctl></div><p class="bf-look__msg" data-bf-look-msg role="status" aria-live="polite"></p></div>';
      el.appendChild(row);
      wire(row, p, true);
    });
    var anchor = tg.anchor && tg.anchor.parentNode === tg.body ? tg.anchor : null;
    if (!anchor) { var items = tg.body.querySelector('[data-section-id="sec-cart-items"]') || tg.body.querySelector('.bf-cd__items'); anchor = items ? items.nextSibling : null; }
    tg.body.insertBefore(el, anchor);
  }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      var need = (c.items || []).length > 0;
      return need ? getData() : null;
    }).then(function () { place(); }).catch(function () {});
  }
  var rq = 0;
  function soon() { clearTimeout(rq); rq = setTimeout(refresh, 300); }
  var f0 = window.fetch;
  if (f0) window.fetch = function (input) {
    var p = f0.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var path = u.replace(location.origin, '').split('?')[0];
      if (/(^|\/)cart\/(add|change|update|clear)(\.js|\.json)?$/.test(path)) p.then(function (r) { if (r && r.ok) soon(); }).catch(function () {});
    } catch (e) {}
    return p;
  };
  function start() {
    pdp();
    new MutationObserver(function () { var h = d.getElementById('smart-cart-host'); if (h && h.shadowRoot && sr !== h.shadowRoot) place(); }).observe(d.body, { childList: true });
    var cd = d.getElementById('bf-cd'); if (cd) new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 120); }).observe(cd, { childList: true, subtree: true });
    refresh();
    /* Safety net (Oct 22): the Smart Cart can draw its drawer after our first pass without a mutation we see, so
       re-check a few times after load and after every open. place() is idempotent. */
    [800, 2000, 4000].forEach(function (ms) { setTimeout(place, ms); });
    var tries = 0;
    (function hook() {
      var rt = window.__SMART_CART_RUNTIME__;
      if (rt && typeof rt.open === 'function' && !rt.__bfLookHook) {
        try { var o = rt.open; rt.open = function () { var r = o.apply(this, arguments); [300, 1000, 2500].forEach(function (ms) { setTimeout(place, ms); }); return r; }; rt.__bfLookHook = 1; } catch (e) {}
      } else if (!rt && tries++ < 20) setTimeout(hook, 500);
    })();
    window.__bfLookPlace = place;
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
